'use client';
import React from 'react';
import { Input, Form, Alert } from 'antd';
import { useTranslations } from 'next-intl';
import InputForm from '@/ui/shared/components/inputForm';
import AfiwaButton from '@/ui/shared/components/afiwaButton';
import { ArrowRightIcon } from '@heroicons/react/20/solid';

import { useController } from './Controller';

type FormPayload = {
  firstName: string;
  lastName: string;
  email: string;
  message: string;
};

export default function ContactForm() {
  const { loading, handleContactEmail, form, getMessageAlert, apiError } =
    useController();

  // texts
  const t = useTranslations('auth');
  const getInText = useTranslations('contact_us.get_in_touch');

  const handleSubmit = (values: FormPayload) => {
    // payload
    const payload = {
      names: values.firstName + ' ' + values.lastName,
      email: values.email,
      message: values.message,
    };
    // api call
    handleContactEmail(payload);
  };

  return (
    <>
      {/* form */}
      <Form
        layout="vertical"
        onFinish={handleSubmit}
        form={form}
        name="contact"
        scrollToFirstError
        requiredMark={false}
      >
        {/* arlert */}

        {apiError && (
          <Alert
            className="!mb-3"
            type={getMessageAlert()?.type}
            message={getMessageAlert()?.message}
          />
        )}

        {/* form */}
        <div className="flex flex-col">
          <div className=" text-xs font-medium text-primary-pale  md:text-sm ">
            {getInText('required_fields')}
          </div>

          {/* FIRST NAME */}
          <InputForm
            label={t('forms.labels.firstName')}
            name="firstName"
            placeholder={t('forms.labels.firstName')}
            rules={[
              {
                required: true,
                message: t('forms.errors.fillUsername'),
                whitespace: true,
              },
              { min: 3, message: t('forms.errors.shortName') },
            ]}
            component={<Input size="large" />}
          />

          {/* LAST NAME */}
          <InputForm
            label={t('forms.labels.lastName')}
            name="lastName"
            placeholder={t('forms.labels.lastName')}
            rules={[
              {
                required: true,
                message: t('forms.errors.fillUsername'),
                whitespace: true,
              },
              { min: 3, message: t('forms.errors.shortName') },
            ]}
            component={<Input size="large" />}
          />

          {/* email */}
          <InputForm
            label={getInText('email')}
            name="email"
            placeholder={getInText('placeholder_mail')}
            rules={[
              { required: true, message: t('forms.errors.fillEmail') },
              { type: 'email', message: t('forms.errors.invalidMail') },
            ]}
            component={
              <Input
                size="large"
                onInput={(e) =>
                  (e.currentTarget.value =
                    e.currentTarget.value.toLocaleLowerCase())
                }
              />
            }
          />
        </div>

        {/* message */}
        <InputForm
          label={getInText('message')}
          name="message"
          placeholder={getInText('placeholder_message')}
          rules={[{ required: true, message: t('forms.placeholders.message') }]}
          component={<Input.TextArea className="!h-[100px]" size="large" />}
        />
        <AfiwaButton
          htmlType="submit"
          loading={loading}
          text={getInText('submit')}
          type="primary"
          className="mt-10"
          rightIcon={<ArrowRightIcon height={15} width={15} />}
        />
      </Form>
    </>
  );
}
